import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, isValid } from 'redux-form';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { getSections } from 'actions/sections';
import { getRemainingSMS, getSMSEducationSections, getSMSMentorSections } from 'actions/sms';
import UserSelect from 'components/List/UserSelect';
import { List, Expandable, Spinner } from 'UI';
import { Flex, Button, Icon } from '@haldor/ui';
import './_smsForm.scss';

var SMSForm = /*#__PURE__*/function (_Component) {
  _inherits(SMSForm, _Component);

  var _super = _createSuper(SMSForm);

  function SMSForm(props) {
    var _this;

    _classCallCheck(this, SMSForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.getRemainingSMS();

      if (_this.props.educationSections == null || _this.props.educationSections.length == 0) {
        _this.props.getSMSEducationSections().then(function () {
          _this.setState({
            loadingEducationSections: false
          });
        });
      } else {
        _this.setState({
          loadingEducationSections: false
        });
      }

      if (_this.props.mentorSections == null || _this.props.mentorSections.length == 0) {
        _this.props.getSMSMentorSections().then(function () {
          _this.setState({
            loadingMentorSections: false
          });
        });
      } else {
        _this.setState({
          loadingMentorSections: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "userSelectLoading", function (loading) {
      _this.setState({
        loading: loading
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      if (_this.props.initialValues != null) {
        _this.props.initialize(_objectSpread({
          sender: 'Haldor'
        }, _this.props.initialValues));

        return false;
      }

      _this.props.initialize({
        sender: 'Haldor'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        values.targetAudience = 'STUDENTS';

        if (values.status == null) {
          values.status = 'SMS_PUBLISHED';
        } // Remove internal form properties from data


        delete values.targetGuardians;
        delete values.targetStudents;

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);
          })["catch"](function (error) {
            _this.setState({
              error: error
            });

            resolve(1);
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onCancel != null) {
        _this.props.onCancel();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (value != null && value !== '') {
        return undefined;
      }

      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "validateRelationships", function (relationships) {
      if (relationships == null || relationships.length == 0) {
        return _this.props.translate('select-relation-error');
      }

      return undefined;
    });

    _this.state = {
      error: null,
      loading: false,
      loadingEducationSections: true,
      loadingMentorSections: true
    };
    return _this;
  }

  _createClass(SMSForm, [{
    key: "render",
    value: function render() {
      var _this$props$titleValu,
          _this$props$titleValu2,
          _this$props$contentVa,
          _this$props$contentVa2,
          _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          translate = _this$props.translate,
          valid = _this$props.valid;
      var numberOfCharacters = 0;
      var numberOfRecipients = 0;
      numberOfCharacters += (_this$props$titleValu = (_this$props$titleValu2 = this.props.titleValue) === null || _this$props$titleValu2 === void 0 ? void 0 : _this$props$titleValu2.length) !== null && _this$props$titleValu !== void 0 ? _this$props$titleValu : 0;
      numberOfCharacters += (_this$props$contentVa = (_this$props$contentVa2 = this.props.contentValue) === null || _this$props$contentVa2 === void 0 ? void 0 : _this$props$contentVa2.length) !== null && _this$props$contentVa !== void 0 ? _this$props$contentVa : 0;
      var numberOfMessages = Math.ceil(numberOfCharacters / 160);

      if (numberOfMessages == 0) {
        numberOfMessages = 1;
      }

      if (this.props.relationshipsValue != null) {
        var students = [];
        this.props.relationshipsValue.forEach(function (relationship) {
          if (relationship.referenceType != 'SECTION' && relationship.mobilePhone != null && relationship.mobilePhone != '') {
            if (relationship.mobilePhone.length > 4 && isValidPhoneNumber(relationship.mobilePhone)) {
              if (students.indexOf(relationship.referenceId) == -1) {
                students.push(relationship.referenceId);
              }
            }
          }
        });
        numberOfRecipients = students.length;
      }

      var amount = numberOfMessages * numberOfRecipients;
      var sections = [];

      if (this.props.educationSections != null) {
        sections = sections.concat(this.props.educationSections);
      }

      if (this.props.mentorSections != null) {
        sections = sections.concat(this.props.mentorSections);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container sms-form"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component file-upload"
      }, this.state.error != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem',
          color: 'red'
        }
      }, this.state.error)) : null, /*#__PURE__*/React.createElement(Expandable, {
        contentStyles: {
          padding: '1em 0rem'
        },
        contentStylesClosed: {
          padding: '0'
        },
        whiteBackground: true,
        title: this.props.translate('students') + '*',
        open: true,
        ignorePropsUpdate: true
      }, !this.state.loadingEducationSections && !this.state.loadingMentorSections ? /*#__PURE__*/React.createElement(List, {
        style: {
          border: '0',
          margin: '0',
          boxShadow: 'none'
        }
      }, /*#__PURE__*/React.createElement(Field, {
        component: UserSelect,
        name: "relationships",
        userSelectDisabled: false,
        showUsersWithoutMentorGroups: true,
        showPhonenumbers: true,
        alwaysFetchStudents: true,
        sections: sections,
        validate: this.validateRelationships,
        setIsLoading: this.userSelectLoading
      })) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('Sender')), /*#__PURE__*/React.createElement(Field, {
        name: "sender",
        type: "text",
        component: "input",
        disabled: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('Content')), /*#__PURE__*/React.createElement("div", {
        className: "fake-input"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement(Field, {
        name: "title",
        type: "text",
        component: "input",
        placeholder: this.props.translate('Title (not required)')
      })), /*#__PURE__*/React.createElement(Field, {
        name: "message",
        type: "textarea",
        component: "textarea",
        validate: this.required,
        placeholder: this.props.translate("Message")
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, this.props.translate('Amount of messages'), ":", /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '1.65rem'
        }
      }, numberOfMessages), this.props.translate('Amount of characters'), ":", /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, 160 * numberOfMessages - numberOfCharacters))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('Sms-debiting')), this.props.remaining != null && this.props.remaining <= this.props.limit ? /*#__PURE__*/React.createElement("div", {
        className: "sms-limit-notice"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert_Red"
      }), this.props.translate('Your school have {{remaining}} sms remaining and need to top up the account.', this.props.remaining)) : null, /*#__PURE__*/React.createElement("table", {
        className: "debit-table",
        cellSpacing: "0"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, this.props.translate('Sms-balance for your school:')), /*#__PURE__*/React.createElement("td", null, this.props.remaining)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, this.props.translate('Number of messages:')), /*#__PURE__*/React.createElement("td", null, numberOfMessages)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        style: {
          paddingBottom: '.65rem'
        }
      }, this.props.translate('Number of recipients:')), /*#__PURE__*/React.createElement("td", {
        style: {
          paddingBottom: '.65rem'
        }
      }, numberOfRecipients)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, this.props.translate('Number of messages that will be sent:')), /*#__PURE__*/React.createElement("td", null, amount))))), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: "SMS_PUBLISHED"
          }));
        }),
        disabled: submitting || !valid || this.state.loading || this.props.remaining - amount < -2000,
        type: "primary"
      }, translate('Send'), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, null) : null), /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: "SMS_DRAFT"
          }));
        }),
        type: "secondary",
        disabled: submitting || !valid || this.state.loading
      }, this.props.translate("save-draft"), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, null) : null), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel'))))));
    }
  }]);

  return SMSForm;
}(Component);

var FORM_NAME = 'SMSForm';
var getFormValue = formValueSelector(FORM_NAME);

function mapStateToProps(state) {
  var contentValue = getFormValue(state, 'message');
  var titleValue = getFormValue(state, 'title');
  var relationshipsValue = getFormValue(state, 'relationships');
  return {
    translate: translate(state.Languages.translations),
    remaining: state.SMS.remaining,
    limit: state.SMS.limit,
    educationSections: state.SMS.educationSections,
    mentorSections: state.SMS.mentorSections,
    contentValue: contentValue,
    titleValue: titleValue,
    relationshipsValue: relationshipsValue
  };
}

export default connect(mapStateToProps, {
  getSections: getSections,
  getRemainingSMS: getRemainingSMS,
  getSMSEducationSections: getSMSEducationSections,
  getSMSMentorSections: getSMSMentorSections
})(reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true
})(SMSForm));